import { render } from "./WowzaLicenseForm.vue?vue&type=template&id=3a9a2db8&scoped=true"
import script from "./WowzaLicenseForm.vue?vue&type=script&lang=js"
export * from "./WowzaLicenseForm.vue?vue&type=script&lang=js"

import "./WowzaLicenseForm.vue?vue&type=style&index=0&id=3a9a2db8&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9a2db8"]])

export default __exports__